import React from 'react';
import Layout from '@/components/Layout';
import { Card, CardContent } from '@/components/ui/card';
import { Trophy } from 'lucide-react';

export default function Rewards({ user, onLogout }) {
  return (
    <Layout user={user} onLogout={onLogout} currentPage="rewards">
      <div className="p-6 lg:p-8 flex items-center justify-center min-h-[70vh]">
        <Card className="border-0 card-shadow bg-white rounded-2xl max-w-2xl w-full">
          <CardContent className="p-12 text-center">
            <div className="w-32 h-32 bg-gradient-to-br from-primary-blue to-[#4AAEFF] rounded-full flex items-center justify-center mx-auto mb-6 animate-pulse">
              <Trophy className="w-16 h-16 text-white" strokeWidth={2} />
            </div>
            
            <h2 className="text-4xl font-bold text-navy mb-4">Coming Soon! 🎁</h2>
            <p className="text-xl text-[#4D4D4D] mb-6 font-light leading-relaxed">
              Enjoy your learning — I'm coming soon to help you<br />
              with amazing rewards and achievements!
            </p>
            
            <div className="bg-blue-50 rounded-xl py-6 px-8 border-2 border-primary-blue/20">
              <p className="text-base text-[#4D4D4D] font-medium">
                We're working on something special for you! 🌟<br />
                Keep learning and stay tuned for exciting rewards.
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
}
